"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner.index"));

var _Button = require("./Button.styles");

var Button = function Button(props) {
  var append = props.append,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      element = props.element,
      label = props.label,
      isLoading = props.isLoading,
      prepend = props.prepend,
      type = props.type,
      spinner = props.spinner,
      dataId = props.dataId;
  var hasChildren = !!children;
  return /*#__PURE__*/_react["default"].createElement(_Button.StyledButton, (0, _extends2["default"])({
    "aria-label": label,
    as: element,
    className: className,
    "data-loading": isLoading,
    disabled: disabled,
    hasChildren: hasChildren,
    type: type,
    "data-id": dataId
  }, props), /*#__PURE__*/_react["default"].createElement("div", null, spinner && isLoading && /*#__PURE__*/_react["default"].createElement(_Button.StyledSpinnerContainer, {
    role: "presentation"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)), children ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, prepend && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-prepended-content"
  }, prepend), /*#__PURE__*/_react["default"].createElement(_Button.StyledButtonLabel, {
    role: "presentation"
  }, label), append && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-appended-content"
  }, append))));
};

Button.defaultProps = {
  append: null,
  children: null,
  className: null,
  color: 'primary',
  disabled: false,
  element: 'button',
  isLoading: false,
  label: '',
  outline: false,
  prepend: null,
  size: 'normal',
  spinner: true,
  type: 'button',
  dataId: ''
};
Button.propTypes = {
  /** Content to be appended to the label */
  append: _propTypes.node,

  /** Fill the button label with any content. If passed, the components properties **append**, **label** and **prepend** and
   * also spacing stylesheets will be ignored. Useful for special cases when buttons should contain images or vector shapes.
   * For default text usage, use the **label** property instead. */
  children: _propTypes.node,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** The color of the button based on the theme. Possible values: */
  color: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary', 'alert']),

  /** Disabled state */
  disabled: _propTypes.bool,

  /** Output HTML element */
  element: (0, _propTypes.oneOf)(['a', 'button']),

  /** If true, spinner will be presented. Please make sure the spinner prop is also enabled. */
  isLoading: _propTypes.bool,

  /** The button label */
  label: _propTypes.string,

  /** Display the outline version */
  outline: _propTypes.bool,

  /** Content to be prepended to the label */
  prepend: _propTypes.node,

  /** The size of the button based on the theme. Possible values: */
  size: (0, _propTypes.oneOf)(['small', 'normal']),

  /** Display the spinner */
  spinner: _propTypes.bool,

  /** The type of the rendered button. Possible values: */
  type: (0, _propTypes.oneOf)(['button', 'submit']),

  /** For Analytics, to hook into events */
  dataId: _propTypes.string
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "append": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Content to be appended to the label",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Fill the button label with any content. If passed, the components properties **append**, **label** and **prepend** and\r\nalso spacing stylesheets will be ignored. Useful for special cases when buttons should contain images or vector shapes.\r\nFor default text usage, use the **label** property instead.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "The color of the button based on the theme. Possible values:",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'alert'",
          "computed": false
        }]
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "element": {
      "defaultValue": {
        "value": "'button'",
        "computed": false
      },
      "description": "Output HTML element",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'a'",
          "computed": false
        }, {
          "value": "'button'",
          "computed": false
        }]
      },
      "required": false
    },
    "isLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, spinner will be presented. Please make sure the spinner prop is also enabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The button label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "outline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Display the outline version",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "prepend": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Content to be prepended to the label",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "The size of the button based on the theme. Possible values:",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }]
      },
      "required": false
    },
    "spinner": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Display the spinner",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'button'",
        "computed": false
      },
      "description": "The type of the rendered button. Possible values:",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'button'",
          "computed": false
        }, {
          "value": "'submit'",
          "computed": false
        }]
      },
      "required": false
    },
    "dataId": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "For Analytics, to hook into events",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Button;
exports["default"] = _default;